module.exports = __webpack_public_path__ + "media/images/bg_service_top_mv_pc-28a6dd7a5f060a162d027fda6c0ef6ad.jpg";